import { INavigationConfig } from '~/src/dash/views/common';

export const platformConnectNavigationConfig: INavigationConfig = {
  tabs: [
    { key: 'Connections', label: 'Connections', value: 0 },
    { key: 'Pending Offers', label: 'Pending Offers', value: 1 },
  ],
};
